import { createContext } from 'react';
import { IVideoCallContext } from '../../models';

export const VideoCallContext = createContext({} as IVideoCallContext);
